var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.quoteSlug)?_c('project-quotes'):_c('project-quote',{attrs:{"quote-slug":_vm.quoteSlug},on:{"slugChange":_vm.setSlug}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }